<div style="width: 300px">
	<cds-modal size="sm" [open]="authStatus === 'unauthenticated'" cdsLayer>
		<cds-modal-header>
			<h1 cdsModalHeaderHeading>
				Welcome to MultiplAI
			</h1>
		</cds-modal-header>
		<div class="cds--modal-content" cdsLayer style="padding: 8px 16px">
			<cds-text-label style="margin-bottom: 8px" [invalid]="emailInvalid" [invalidText]="emailInvalidText">
				Email
				<input (keyup.enter)="signUp()" (keyup)="onKeyUpEmail($event)" size="md" name="email" [(ngModel)]="email" cdsText>
			</cds-text-label>

			<cds-text-label style="margin-top: 8px" [invalid]="passwordInvalid" [invalidText]="passwordInvalidText">
				Password
				<input (keyup.enter)="signUp()" (keyup)="onKeyUpPassword($event)" [(ngModel)]="password" type="password" cdsText>
			</cds-text-label>

			<cds-text-label style="margin-top: 8px" [invalid]="confirmPasswordInvalid" [invalidText]="confirmPasswordInvalidText">
				Confirm password
				<input (keyup.enter)="signUp()" (keyup)="onKeyUpConfirmPassword($event)" [(ngModel)]="confirmPassword" type="password" cdsText>
			</cds-text-label>

			<cds-text-label style="margin-top: 16px">
				<span>Already have an account?</span>&nbsp;
				<a (click)="navigateToPage('login')">Sign in</a>
			</cds-text-label>
		</div>

		<cds-modal-footer>
			<button cdsButton="primary" (keyup.enter)="signUp()" (click)="signUp()" class="cds--btn">
				Sign Up
			</button>
		</cds-modal-footer>
	</cds-modal>

</div>

